export default {
    mainEvent: null,
    eventList: null,
    liveEvents: null,
    talkEvents: null,
    expertsLive: null,
    expertsTalk: null,
    userEvents: null,
    selectedEvent: null,
    eventUsers: null,
    userSig: null,
    unAuthUserSig: null,
    isUserAnonymous: 0,
    bannerEvent: 0,
    liveEventsArchive: null,
    archivePlaylist: null,
    monthEvents: null,
    corpAllEvents: null,
    corpPrivateEvents: null,
    corpPublicEvents: null,
    corpMainEvent: null,
    corpArchiveEvents: null,
    corpPlaylists: null,
    demoEvent: null,
    corpPrivateVideos: null,
    demoUserStatus: null,
    upcomingEvent: null
}



// WEBPACK FOOTER //
// ./src/store/events/state.js